'use strict';

var availabilityStatus = require('../../../../../../../../_virtual/availabilityStatus.cjs');

var AvailabilityStatus = /*#__PURE__*/ function(AvailabilityStatus) {
    AvailabilityStatus["available"] = "Available";
    AvailabilityStatus["in_stock"] = "In Stock";
    AvailabilityStatus["backordered"] = "Backordered";
    AvailabilityStatus["vendor_backorder"] = "Vendor backorder";
    AvailabilityStatus["unavailable"] = "Unavailable";
    AvailabilityStatus["discontinued"] = "Discontinued";
    AvailabilityStatus["to_be_discontinued"] = "To be discontinued";
    AvailabilityStatus["na"] = "n/a";
    AvailabilityStatus["new"] = "New";
    AvailabilityStatus["not_in_catalog"] = "Not in catalog";
    return AvailabilityStatus;
}({});

availabilityStatus.__exports.AvailabilityStatus = AvailabilityStatus;

module.exports = availabilityStatus.__exports;
//# sourceMappingURL=availabilityStatus.cjs.map
